export enum FollowUpActionStatusType {
	ADDRESS_SEARCH = "address-search",
	ADDRESS_SELECTED = "address-selected",
	APARTMENT_SELECTED = "apartment-selected",
	BROKEN = "broken",
	STOPPED = "stopped",
	BUNDLE_STEP = "bundle-step",
	ORDER_SENT = "order-sent",
	ORDER_CANCELLED = "order-cancelled",
	LAST_ORDER_SENT = "last-order-sent",
	LAST_ORDER_CANCELLED = "last-order-cancelled",
	COMPLETED = "completed",
	DELETE_BLOCKING_STEP = "delete-blocking-step",
	DELETE_STEP = "delete-step",
	EXTRAS_SELECTED = "extras-selected",
	FEATURES_SELECTED = "features-selected",
	FRESH = "fresh",
	FRESH_2ND_PHASE = "fresh-2nd-phase",
	GROUPED = "grouped",
	INTERMEDIATE_ORDER_CANCELLED = "intermediate-order-cancelled",
	INTERMEDIATE_ORDER_COMPLETED = "intermediate-order-completed",
	INTERMEDIATE_ORDER_DATA_SAVED = "intermediate-order-data-saved",
	INTERMEDIATE_ORDER_SENT = "intermediate-order-sent",
	INTERMEDIATE_PRODUCT_BROKEN = "intermediate-product-broken",
	INTERMEDIATE_PRODUCT_TERMINATED = "intermediate-product-terminated",
	INTERMEDIATE_SHOPPING_CART_CONFIGURED = "intermediate-shopping-cart-configured",
	INTERMEDIATE_SHOPPING_CART_SAVED = "intermediate-shopping-cart-saved",
	INTERMEDIATE_SHOPPING_CART_VOIP_HANDLED = "intermediate-shopping-cart-voip-handled",
	MODIFICATION_SELECTED = "modification-selected",
	ORDER_DATA_SAVED = "order-data-saved",
	READY_TO_GROUP = "ready-to-group",
	SHOPPING_CART_CONFIGURED = "shopping-cart-configured",
	SHOPPING_CART_SAVED = "shopping-cart-saved",
	TRANSITION_SELECTED = "transition-selected",
	UNBUNDLE_STEP = "unbundle-step",
	SUBMIT_FAILED = "submit-failed"
}

const DISABLED_STATUSES: FollowUpActionStatusType[] = [
	FollowUpActionStatusType.ORDER_SENT,
	FollowUpActionStatusType.LAST_ORDER_SENT,
	FollowUpActionStatusType.UNBUNDLE_STEP,
	FollowUpActionStatusType.DELETE_STEP,
	FollowUpActionStatusType.DELETE_BLOCKING_STEP,
	FollowUpActionStatusType.BUNDLE_STEP,
	FollowUpActionStatusType.GROUPED,
	FollowUpActionStatusType.BROKEN,
	FollowUpActionStatusType.STOPPED,
	FollowUpActionStatusType.SUBMIT_FAILED
];

export const BUNDLE_DISABLED_STATUS: FollowUpActionStatusType[] = [...DISABLED_STATUSES, FollowUpActionStatusType.COMPLETED];

export const PROMOTION_DISABLED_STATUS: FollowUpActionStatusType[] = [...BUNDLE_DISABLED_STATUS, FollowUpActionStatusType.FRESH];

export const CONFIGURATION_DISABLED_STATUS: FollowUpActionStatusType[] = [
	...PROMOTION_DISABLED_STATUS,
	FollowUpActionStatusType.MODIFICATION_SELECTED,
	FollowUpActionStatusType.TRANSITION_SELECTED,
	FollowUpActionStatusType.EXTRAS_SELECTED
];

export const ORDER_DATA_DISABLED_STATUS: FollowUpActionStatusType[] = [
	...CONFIGURATION_DISABLED_STATUS,
	FollowUpActionStatusType.FEATURES_SELECTED,
	FollowUpActionStatusType.SHOPPING_CART_SAVED
];

const CHANGE_OF_ADDRESS_1ST_PHASE_STATUSES: FollowUpActionStatusType[] = [
	FollowUpActionStatusType.FRESH,
	FollowUpActionStatusType.ADDRESS_SEARCH,
	FollowUpActionStatusType.ADDRESS_SELECTED,
	FollowUpActionStatusType.APARTMENT_SELECTED,
	FollowUpActionStatusType.INTERMEDIATE_SHOPPING_CART_CONFIGURED,
	FollowUpActionStatusType.INTERMEDIATE_SHOPPING_CART_SAVED,
	FollowUpActionStatusType.INTERMEDIATE_SHOPPING_CART_VOIP_HANDLED,
	FollowUpActionStatusType.INTERMEDIATE_ORDER_DATA_SAVED,
	FollowUpActionStatusType.INTERMEDIATE_ORDER_SENT,
	FollowUpActionStatusType.INTERMEDIATE_ORDER_COMPLETED,
	FollowUpActionStatusType.INTERMEDIATE_ORDER_CANCELLED,
	FollowUpActionStatusType.INTERMEDIATE_PRODUCT_BROKEN,
	FollowUpActionStatusType.INTERMEDIATE_PRODUCT_TERMINATED
];

export const CANCEL_CHANGE_OF_ADDRESS_STATUSES = [
	FollowUpActionStatusType.FRESH,
	FollowUpActionStatusType.ADDRESS_SEARCH,
	FollowUpActionStatusType.ADDRESS_SELECTED,
	FollowUpActionStatusType.APARTMENT_SELECTED,
	FollowUpActionStatusType.INTERMEDIATE_SHOPPING_CART_CONFIGURED,
	FollowUpActionStatusType.INTERMEDIATE_SHOPPING_CART_SAVED,
	FollowUpActionStatusType.INTERMEDIATE_ORDER_DATA_SAVED
];

const CHANGE_OF_ADDRESS_2ST_PHASE_STATUSES: FollowUpActionStatusType[] = [
	FollowUpActionStatusType.FRESH_2ND_PHASE,
	FollowUpActionStatusType.SHOPPING_CART_CONFIGURED,
	FollowUpActionStatusType.SHOPPING_CART_SAVED,
	FollowUpActionStatusType.ORDER_DATA_SAVED,
	FollowUpActionStatusType.FEATURES_SELECTED
];

export const COVERAGE_CHANGE_OF_ADDRESS_DISABLED_STATUS: FollowUpActionStatusType[] = [
	FollowUpActionStatusType.INTERMEDIATE_ORDER_SENT,
	FollowUpActionStatusType.INTERMEDIATE_ORDER_COMPLETED,
	FollowUpActionStatusType.INTERMEDIATE_ORDER_CANCELLED,
	FollowUpActionStatusType.INTERMEDIATE_PRODUCT_BROKEN,
	FollowUpActionStatusType.INTERMEDIATE_PRODUCT_TERMINATED,
	...CHANGE_OF_ADDRESS_2ST_PHASE_STATUSES,
	...DISABLED_STATUSES,
	FollowUpActionStatusType.COMPLETED
];

export const INTERMEDIATE_CONFIGURATION_CHANGE_OF_ADDRESS_DISABLED_STATUS: FollowUpActionStatusType[] = [
	...COVERAGE_CHANGE_OF_ADDRESS_DISABLED_STATUS,
	FollowUpActionStatusType.FRESH,
	FollowUpActionStatusType.ADDRESS_SEARCH,
	FollowUpActionStatusType.ADDRESS_SELECTED
];

export const INTERMEDIATE_ORDER_CHANGE_OF_ADDRESS_DISABLED_STATUS: FollowUpActionStatusType[] = [
	...INTERMEDIATE_CONFIGURATION_CHANGE_OF_ADDRESS_DISABLED_STATUS,
	FollowUpActionStatusType.APARTMENT_SELECTED
];

export const PROMOTION_CHANGE_OF_ADDRESS_DISABLED_STATUS: FollowUpActionStatusType[] = [
	...CHANGE_OF_ADDRESS_1ST_PHASE_STATUSES,
	...DISABLED_STATUSES,
	FollowUpActionStatusType.COMPLETED
];

export const CONFIGURATION_CHANGE_OF_ADDRESS_DISABLED_STATUS: FollowUpActionStatusType[] = [
	...PROMOTION_CHANGE_OF_ADDRESS_DISABLED_STATUS,
	FollowUpActionStatusType.FRESH_2ND_PHASE
];

export const ORDER_CHANGE_OF_ADDRESS_DISABLED_STATUS: FollowUpActionStatusType[] = [
	...CONFIGURATION_CHANGE_OF_ADDRESS_DISABLED_STATUS,
	FollowUpActionStatusType.FEATURES_SELECTED,
	FollowUpActionStatusType.SHOPPING_CART_SAVED
];
